import React, { useEffect, useRef } from 'react';
import PageHeader from '../common/PageHeader';
import { logger } from '../../utils/logger';
import '../../styles/Impressum.css';

const Impressum: React.FC = () => {
  const contentSectionRef = useRef<HTMLElement | null>(null);

  // Function to check if elements are in viewport to apply fade effect
  const checkFade = () => {
    if (contentSectionRef.current) {
      const elementTop = contentSectionRef.current.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      if (elementTop < windowHeight - 100) {
        contentSectionRef.current.classList.add('active');
      }
    }
  };

  // Set up fade effect on scroll
  useEffect(() => {
    // Initial check
    checkFade();
    
    // Log page visit
    logger.info('📃 Impressum page visited', { component: 'Impressum' });

    // Add scroll event listener
    window.addEventListener('scroll', checkFade);

    // Clean up
    return () => {
      window.removeEventListener('scroll', checkFade);
    };
  }, []);

  return (
    <>      <PageHeader
        title="Impressum"
        subtitle="Legal Information"
      />

      <section className="container fade-in" ref={contentSectionRef}>
        <div className="imp-container">
          <h1 className="imp-title">Impressum</h1>
          <div className="imp-content">
          <h2>Angaben gemäß § 5 TMG</h2>
          <div className="imp-address">
            <p>BodySharing GmbH</p>
            <p>Musterstraße 123</p>
            <p>12345 Musterstadt</p>
            <p>Deutschland</p>
          </div>
        
          <section className="imp-section">
            <h2>Kontakt</h2>
            <p>Telefon: <a href="tel:+49123456789">+49 123 456789</a></p>
            <p>E-Mail: <a href="mailto:contact@bodysharing-berlin.de">contact@bodysharing-berlin.de</a></p>
          </section>
        
          <section className="imp-section">
            <h2>Vertreten durch</h2>
            <p>Max Mustermann, Geschäftsführer</p>
          </section>
        
          <section className="imp-section">
            <h2>Handelsregister</h2>
            <p>HRB 12345</p>
            <p>Amtsgericht Musterstadt</p>
          </section>
        
          <section className="imp-section">
            <h2>Umsatzsteuer-ID</h2>
            <p>Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:</p>
            <p>DE123456789</p>
          </section>
        
          <section className="imp-section">
            <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <div className="imp-address">
              <p>Max Mustermann</p>
              <p>Musterstraße 123</p>
              <p>12345 Musterstadt</p>
              <p>Deutschland</p>
            </div>
          </section>

          <section className="imp-section">
            <h2>Streitschlichtung</h2>
            <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a>.</p>
            <p>Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
            <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>          </section>
          </div>
        </div>
      </section>
    </>
  );
};

export default Impressum;
